import { isNumber } from './typeguards.js';

/**
 * Generates a unique ID string that can be used as an identifier for a html element.
 *
 * The ID is prefixed with an underscore followed by a random alphanumeric string.
 *
 * An HTML element ID must be unique within a document and can contain any characters,
 * but it must not start with a digit and should not contain spaces.
 *
 * The specification does not set an explicit limit on the length of an ID,
 * but it's generally recommended to keep it reasonable (less than 100 characters).
 *
 * @example
 * const id = generateId();
 * console.log(id); // Output might be something like "_k3s9yf7a"
 *
 * @returns A unique ID string.
 */
export const generateId = () => `_${Math.random().toString(36).substring(2, 11)}`;

/**
 * Generates a random number string of a specified length.
 * If the input length is not a valid number, a default length of 9 is used.
 *
 * @example
 * const randomNumberString = generateRandomNumberString(5);
 * console.log(randomNumberString); // Output might be something like "83647"
 *
 * @param lengthOfRandomNumber The desired length of the random number string.
 * @returns A string representing a random number of the specified length.
 */
export const generateRandomNumberString = (lengthOfRandomNumber?: number) => {
    const length = (isNumber(lengthOfRandomNumber)) ? lengthOfRandomNumber : 9;
    let randomString = '';
    // continue appending random strings until the requested length is reached
    while (randomString.length < length) {
        randomString += Math.random().toString().substring(2);
    }
    return randomString.slice(0, length);
};
